import { supabase } from "@/utils/supabase";
import { ChargingStationMapper } from "@/adapters/ChargingStation.mapper";
import { getRootStore } from "@/stores/RootStore";
/**
 * Concrete implementation of ChargingStationService
 * Handles all database operations for charging stations
 */
export class ChargingStationService {
    async getStationsWithParams(params) {
        try {
            let query = supabase()
                .from("ChargingStations")
                .select("*", { count: "exact" })
                .eq("isDeleted", false);
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [`serialNumber.ilike.*${search}*`];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("serialNumber", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(ChargingStationMapper.toDomain),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getStationsWithParams:", error);
            throw error;
        }
    }
    async getStationsByIds(ids) {
        if (!ids.length)
            return [];
        const { data, error } = await supabase()
            .from("ChargingStations")
            .select("*")
            .in("id", ids)
            .eq("isDeleted", false)
            .order("serialNumber");
        if (error)
            throw error;
        return data.map(ChargingStationMapper.toDomain);
    }
    async createStation(station) {
        const { data, error } = await supabase()
            .from("ChargingStations")
            .insert([
            {
                ...ChargingStationMapper.toCreateDto(station),
                idCreatedBy: getRootStore().authStore.user?.id,
            },
        ])
            .select("*")
            .single();
        if (error)
            throw error;
        return ChargingStationMapper.toDomain(data);
    }
    async updateStation(id, station) {
        const { data, error } = await supabase()
            .from("ChargingStations")
            .update({
            ...ChargingStationMapper.toCreateDto(station),
            idUpdatedBy: getRootStore().authStore.user?.id,
        })
            .eq("id", id)
            .select("*")
            .single();
        if (error)
            throw error;
        return ChargingStationMapper.toDomain(data);
    }
    async deleteStation(id) {
        const { error } = await supabase()
            .from("ChargingStations")
            .update({
            isDeleted: true,
            idUpdatedBy: getRootStore().authStore.user?.id,
        })
            .eq("id", id);
        if (error)
            throw error;
    }
}
// Export singleton instance
export const chargingStationService = new ChargingStationService();
